import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M19.75 4.25a3.417 3.417 0 0 0-5.735 3.234L9.312 9.836a3.417 3.417 0 1 0 0 4.329l4.703 2.35a3.417 3.417 0 1 0 .67-1.342l-4.701-2.35a3.43 3.43 0 0 0 0-1.646l4.7-2.35q.109.132.233.256a3.417 3.417 0 0 0 4.832-4.832m-1.061 1.061a1.917 1.917 0 1 0-2.712 2.711 1.917 1.917 0 0 0 2.712-2.71M8.023 10.644a1.917 1.917 0 1 0-2.712 2.712 1.917 1.917 0 0 0 2.712-2.712m7.954 5.333a1.917 1.917 0 1 1 2.712 2.712 1.917 1.917 0 0 1-2.712-2.712",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }